/**
 * jr-help-center.js — the /pages/help page (sections/jr-help-center.liquid).
 *
 * Three jobs: hand a typed question to the chat widget (`jr-help:ask`),
 * render the answers from the backend's `articles` action (the same Docs
 * document Jasper reads), and send the "reach a person" form to `contact`.
 * No framework; the only network calls are the jr-help endpoint.
 */
(function () {
  'use strict';
  var root = document.getElementById('JrHelpCenter');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint');
  var $ = function (id) { return document.getElementById(id); };

  // ---- Ask Jasper ---------------------------------------------------------------
  // The question box is the front door; the first question EXPANDS it into the
  // chat (the same widget, moved in here — same session, same transcript). A
  // returning visitor mid-conversation gets the chat straight away.
  var host = $('JrhcChatHost'), askForm = $('JrhcAsk');
  var expanded = false;
  function widgetOnPage() { return !!(document.getElementById('JrHelp') && document.getElementById('JrHelpPanel')); }
  function widgetReady() { var w = document.getElementById('JrHelp'); return !!(w && w.getAttribute('data-ready') === 'true'); }
  function expandChat() {
    if (expanded || !host || !widgetReady()) return false;
    expanded = true;
    root.classList.add('jrhc--chat-open');
    document.dispatchEvent(new CustomEvent('jr-help:inline', { detail: { host: host } }));
    return true;
  }
  function whenReady(fn) {
    if (widgetReady()) { fn(); return; }
    var done = false, go = function () { if (done) return; done = true; fn(); };
    document.addEventListener('jr-help:ready', go, { once: true });
    var tries = 0, poll = function () { if (done) return; if (widgetReady()) go(); else if (++tries < 40) setTimeout(poll, 150); };
    setTimeout(poll, 150);
  }
  function ask(text) {
    text = (text || '').trim();
    if (!text) return;
    if (widgetOnPage()) {
      whenReady(function () {
        expandChat();
        // Let the panel land in the page before the message goes, so the reply
        // streams into a box the customer can see.
        setTimeout(function () { document.dispatchEvent(new CustomEvent('jr-help:ask', { detail: { text: text, from: 'help-center' } })); }, 120);
      });
    } else {
      // The widget is not on this theme (live before go-live): fall back to the person form.
      var m = $('JrhcMessage'); if (m) { m.value = text; m.focus(); }
      var c = $('contact'); if (c) c.scrollIntoView({ behavior: 'smooth' });
    }
  }
  if (askForm) askForm.addEventListener('submit', function (e) { e.preventDefault(); ask($('JrhcAskInput').value); $('JrhcAskInput').value = ''; });
  var chips = $('JrhcChips');
  if (chips) chips.addEventListener('click', function (e) { var b = e.target.closest('[data-ask]'); if (b) ask(b.getAttribute('data-ask')); });
  // Mid-conversation already? Show the chat instead of the box.
  (function resumeIfTalking() {
    var talking = false;
    try { var box = JSON.parse(localStorage.getItem('jrhelp:transcript') || 'null'); talking = !!(box && box.v && box.v.some && !(box.exp && Date.now() > box.exp) && box.v.some(function (m) { return m && m.role === 'customer'; })); } catch (e) {}
    if (!talking || !widgetOnPage()) return;
    whenReady(expandChat);
  })();

  // ---- The answers ---------------------------------------------------------------
  var articles = $('JrhcArticles'), nav = $('JrhcNav'), filter = $('JrhcFilter');
  var data = null;
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  // Answers are plain markdown-ish text from Docs: paragraphs, "- " bullets,
  // and our own links. Rendered by hand so nothing but text and same-domain
  // links reaches the DOM.
  var LINK_RE = /(https?:\/\/(?:www\.)?jeremysrazors\.com\/[^\s)]*|\/(?:pages|products|collections|account|cart)[^\s)]*|mailto:[^\s)]+)/g;
  function inline(node, text) {
    var last = 0, m; LINK_RE.lastIndex = 0;
    while ((m = LINK_RE.exec(text))) {
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      var href = m[0].replace(/[.,]$/, '');
      var a = el('a', 'jrhc__link', href.indexOf('mailto:') === 0 ? href.slice(7) : href.replace(/^https?:\/\/(?:www\.)?jeremysrazors\.com/, ''));
      a.href = href;
      node.appendChild(a);
      last = m.index + href.length;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
  }
  function renderAnswer(text) {
    var wrap = el('div', 'jrhc__answer');
    var blocks = String(text || '').split(/\n\s*\n/);
    blocks.forEach(function (b) {
      var lines = b.split('\n').filter(function (l) { return l.trim(); });
      if (!lines.length) return;
      if (lines.every(function (l) { return /^\s*(-|\d+\.)\s+/.test(l); })) {
        var list = el(/^\s*\d+\./.test(lines[0]) ? 'ol' : 'ul');
        lines.forEach(function (l) { var li = el('li'); inline(li, l.replace(/^\s*(-|\d+\.)\s+/, '')); list.appendChild(li); });
        wrap.appendChild(list);
      } else {
        var p = el('p'); inline(p, lines.join(' ')); wrap.appendChild(p);
      }
    });
    return wrap;
  }

  function render(q) {
    if (!data) return;
    articles.innerHTML = '';
    var needle = (q || '').trim().toLowerCase();
    var shown = 0, ld = [];
    data.sections.forEach(function (sec) {
      var items = sec.items.filter(function (it) { return !needle || (it.q + ' ' + it.a).toLowerCase().indexOf(needle) !== -1; });
      if (!items.length) return;
      var id = 'help-' + slug(sec.title);
      // Five big categories, closed until tapped (Jon, 2026-09-17: "The giant
      // list of topics is so overwhelming. Can't we just expand by those big
      // categories and then the smaller ones?"). A search opens the categories
      // that match so the hits are visible.
      var box = el('details', 'jrhc__section'); box.id = id;
      var head = el('summary', 'jrhc__h2');
      head.appendChild(el('span', 'jrhc__h2-text', sec.title));
      head.appendChild(el('span', 'jrhc__h2-count', items.length + (items.length === 1 ? ' answer' : ' answers')));
      box.appendChild(head);
      if (needle) box.open = true;
      box.addEventListener('toggle', function () { if (box.open) track('section_opened', { section: sec.title.slice(0, 60) }); });
      items.forEach(function (it) {
        var d = el('details', 'jrhc__item'); d.id = 'q-' + slug(it.q);
        var s = el('summary', 'jrhc__q', it.q);
        d.appendChild(s);
        d.appendChild(renderAnswer(it.a));
        // Every answer ends with the shortcut: a button that opens the chat with
        // the request already sent. The Docs document names the request per
        // answer ("Ask Jasper: Skip my next shipment"); without one, the
        // question itself is sent.
        var askText = it.ask || it.q;
        var askRow = el('div', 'jrhc__ask-row');
        askRow.appendChild(el('span', 'jrhc__ask-label', document.getElementById('JrHelp') ? 'Or let Jasper handle it:' : 'Or ask us:'));
        var askBtn = el('button', 'jrhc__ask-pill', '“' + askText + '”'); askBtn.type = 'button';
        askBtn.addEventListener('click', function () { track('article_asked', { q: it.q.slice(0, 80) }); ask(askText); });
        askRow.appendChild(askBtn);
        d.appendChild(askRow);
        d.addEventListener('toggle', function () { if (d.open) track('article_opened', { q: it.q.slice(0, 80) }); });
        box.appendChild(d);
        ld.push({ '@type': 'Question', name: it.q, acceptedAnswer: { '@type': 'Answer', text: it.a } });
        shown++;
      });
      articles.appendChild(box);
    });
    if (!shown) {
      var none = el('div', 'jrhc__none');
      none.appendChild(el('p', '', needle ? 'Nothing here matches "' + q.trim() + '".' : 'No answers published yet.'));
      var b = el('button', 'jrhc__chip', 'Ask Jasper instead'); b.type = 'button';
      b.addEventListener('click', function () { ask(q); });
      none.appendChild(b);
      articles.appendChild(none);
    }
    if (!needle && ld.length) {
      var old = document.getElementById('JrhcLd'); if (old) old.remove();
      var sc = el('script'); sc.id = 'JrhcLd'; sc.type = 'application/ld+json';
      sc.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: ld });
      document.head.appendChild(sc);
    }
    // Deep link: /pages/help#q-how-do-i-cancel-…
    if (location.hash && /^#(q|help)-/.test(location.hash)) {
      var t = document.getElementById(location.hash.slice(1));
      if (t) { t.open = true; var sec = t.closest('.jrhc__section'); if (sec) sec.open = true; t.scrollIntoView(); }
    }
  }
  var filterTimer = null;
  if (filter) filter.addEventListener('input', function () { clearTimeout(filterTimer); filterTimer = setTimeout(function () { render(filter.value); if (filter.value.trim()) track('articles_searched', { q: filter.value.trim().slice(0, 60) }); }, 150); });

  fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'articles' }) })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      if (!j || !j.ok || !j.sections) throw new Error('no articles');
      data = j;
      render(filter ? filter.value : '');
    })
    .catch(function () {
      articles.innerHTML = '';
      var p = el('p', 'jrhc__none', 'The answers didn’t load. Ask Jasper above, or send us a note below.');
      articles.appendChild(p);
    });

  // ---- Reach a person ----------------------------------------------------------
  var form = $('JrhcContact'), note = $('JrhcContactNote');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = form.elements;
    var name = f.name.value.trim(), email = f.email.value.trim(), msg = f.message.value.trim(), order = f.order_number.value.trim();
    if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) || msg.length < 5) {
      note.textContent = 'Your name, a real email, and a few words about the problem — then we can help.';
      note.className = 'jrhc__note jrhc__note--err';
      return;
    }
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true; note.textContent = 'Sending…'; note.className = 'jrhc__note';
    fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'contact', name: name, email: email, order_number: order, message: msg, company: f.company.value, page: { path: location.pathname } }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, j: j }; }); })
      .then(function (res) {
        if (res.status === 429) throw new Error('rate');
        if (!res.j || !res.j.ok) throw new Error((res.j && res.j.error) || 'failed');
        track('contact_sent', { has_order: !!order });
        form.reset();
        note.textContent = 'Got it — ' + (res.j.ticket_id ? 'request #' + res.j.ticket_id + ' is with our team. ' : 'it’s with our team. ') + 'You’ll hear back by email.';
        note.className = 'jrhc__note jrhc__note--ok';
        btn.disabled = false;
      })
      .catch(function (err) {
        btn.disabled = false;
        note.textContent = err.message === 'rate'
          ? 'That’s a few in a row — give it a little while, or email support@jeremysrazors.com.'
          : 'That didn’t go through. Email support@jeremysrazors.com and we’ll pick it up there.';
        note.className = 'jrhc__note jrhc__note--err';
      });
  });

  // ---- A little telemetry, through the widget's own channel when present -----
  function track(name, props) {
    try { document.dispatchEvent(new CustomEvent('jr-help:track', { detail: { name: 'help_center_' + name, props: props || {} } })); } catch (e) {}
  }
})();
